export default {
  data() {
    return {
      sale_bpm_steps: {
        interest: 1,
        kp: 2,
        contract_sent: 3,
        payment_wait: 4,
        paid: 5,
        denied: 6,
        booked: 7,
        lead_market: 99,
      },
    }
  },
}
